import { useState } from 'react';
import { StatusFilter } from 'domain/shared/newProject';
import { Filter, DropDownFilterInputLayout, ListFiltersLayout, ListItem } from 'framework/list';
import { FilterCondition } from 'framework/types';
import { UiThemeOverrider } from 'framework/uiTheme';
import { ASSIGNMENTS_STATUS_FILTER_OPTIONS } from 'domain/shared/assignment/constants';
import { StaffingAssignmentListMember, StaffingAssignmentSlot } from 'domain/shared/staffing';
import { FormFieldsData } from 'framework/form';

const MEMBER_STATUS_SOURCE = 'members.status';

export const useAssignmentsBlock = (data: StaffingAssignmentSlot[]) => {
  const [filters, setFilters] = useState<Filter>({});

  const applyOperator = (fieldValue: string, operator: string, expectedValue: FormFieldsData) => {
    switch (operator) {
      case FilterCondition.IN:
        return expectedValue.includes(fieldValue);
      default:
        return false;
    }
  };

  const filteredData = (): ListItem[] => {
    if (!filters) return data;

    const filterByMember = filters?.[MEMBER_STATUS_SOURCE];

    return (
      data
        .map((item: ListItem) => ({
          ...item,
          members: item?.members?.filter((member: StaffingAssignmentListMember) => {
            if (!filterByMember) return true;
            const fieldValue = member?.status;
            return Object.entries(filterByMember).every(([operator, expectedValue]) =>
              applyOperator(fieldValue, operator, expectedValue),
            );
          }),
        }))
        .filter((item: ListItem) => {
          return Object.entries(filters).every(([fieldName, rule]) => {
            if (fieldName === MEMBER_STATUS_SOURCE) {
              return true;
            }

            const fieldValue = item[fieldName];
            return Object.entries(rule).every(([operator, expectedValue]) =>
              applyOperator(fieldValue, operator, expectedValue),
            );
          });
        }) || []
    );
  };

  const contextValue = {
    data: { items: filteredData() },
    loading: false,
    filters,
    filterBy: setFilters,
  };

  const assignmentsFilters = (
    <UiThemeOverrider
      overriddenLayouts={{
        DropdownLayout: DropDownFilterInputLayout,
      }}
    >
      <ListFiltersLayout>
        <StatusFilter source={MEMBER_STATUS_SOURCE} options={ASSIGNMENTS_STATUS_FILTER_OPTIONS} />
      </ListFiltersLayout>
    </UiThemeOverrider>
  );

  return {
    contextValue,
    assignmentsFilters,
  };
};
